import React from 'react'

import CompanyActions from '@/components/misc/CompanyProfile/components/CompanyProfileHeader/CompanyActions'
import CompanyInfo from '@/components/misc/CompanyProfile/components/CompanyProfileHeader/CompanyInfo'
import DataDisclaimer from '@/components/misc/CompanyProfile/components/CompanyProfileHeader/DataDisclaimer'
import { useIsCompanyProfileModal } from '@/components/misc/CompanyProfile/hooks/useIsCompanyProfileModal'
import { cn } from '@/lib/utils'
import { CompanyProfileItem } from '@/types/responses/companies'

interface Props {
  companyProfile: CompanyProfileItem
}

const CompanyProfileHeader: React.FC<Props> = ({ companyProfile }) => {
  const isCompanyProfileModal = useIsCompanyProfileModal()

  return (
    <section
      className={cn('mb-2 px-5 pb-5', {
        'border-0 shadow-none': isCompanyProfileModal,
      })}
    >
      <div
        className={cn('text-black', {
          'pt-0': isCompanyProfileModal,
        })}
      >
        <header className="flex flex-col gap-4 sm:gap-x-6">
          <CompanyInfo companyProfile={companyProfile} />
          <CompanyActions companyProfile={companyProfile} />
        </header>

        {!companyProfile.isRegistered && <DataDisclaimer />}
      </div>
    </section>
  )
}

export default CompanyProfileHeader
